import { render, staticRenderFns } from "./catfoot.vue?vue&type=template&id=4e36257c&scoped=true&"
import script from "./catfoot.vue?vue&type=script&lang=js&"
export * from "./catfoot.vue?vue&type=script&lang=js&"
import style0 from "./catfoot.vue?vue&type=style&index=0&id=4e36257c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36257c",
  null
  
)

export default component.exports